import { useBlackfeo } from "@/hooks/use-blackfeo";
import { BlackfeoDestaque } from "@/components/blackfeo/BlackfeoPontos";
import { BLACK_CTA_VENDA, BLACK_ULTIMOS_DIAS } from "@/lib/black2x1/escassez";
import { useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { useBlackSale } from "@/hooks/use-black-sale";

import { posParaCategorias } from "@/lib/blog/pos-por-categoria";
import logoBlack from "@/assets/black2x1/black-logo-oficial.webp.asset.json";
import { blackListaHref, instalarOrigemBlack } from "@/lib/black2x1/origem-visita";

// Fim das inscrições da BLACK 2x1: 03/11/2026 23h59 (Brasília).
const BLACK_FIM = Date.parse("2026-11-04T02:59:59Z");

/**
 * CTA dos artigos do E-FISIO. Durante a BLACK 2x1 leva à lista (/black-lista)
 * com texto da pós ligada à área do artigo; depois volta ao CTA da pós.
 */
export { BLACK_FIM };

type PosCtaProps = { categorias: string[] | null | undefined; posicao?: "meio" | "fim" };
export function PosCta(props: PosCtaProps) {
  const blackfeo = useBlackfeo();
  return blackfeo ? <BlackfeoDestaque ponto={`efisio-artigo-${props.posicao ?? "fim"}`} compacto /> : <PosCtaPadrao {...props} />;
}

function PosCtaPadrao({ categorias, posicao = "fim" }: PosCtaProps) {
  const pos = posParaCategorias(categorias);
  const sale = useBlackSale();
  useEffect(() => instalarOrigemBlack(), []);
  const black = Date.now() <= BLACK_FIM;

  if (black) {
    return (
      <aside
        className="overflow-hidden rounded-2xl bg-[#0b0a14] px-6 py-8 text-center text-white sm:py-10"
        style={{ backgroundImage: "radial-gradient(circle at 100% 0%, rgba(124,58,237,0.35), transparent 50%), radial-gradient(circle at 0% 100%, rgba(124,58,237,0.25), transparent 45%)" }}
      >
        {sale ? (
          <p className="mb-3 flex items-center justify-center gap-1.5 text-[11px] font-extrabold uppercase tracking-[0.18em] text-[#2fe0d6] sm:text-xs">🔥 {BLACK_ULTIMOS_DIAS} · vendas abertas</p>
        ) : null}
        <img src={logoBlack.url} alt="Pós FEO em Dobro" loading="lazy" decoding="async" className="mx-auto h-auto w-56 sm:w-72" />
        <p className="mt-4 bg-gradient-to-r from-[#a78bfa] to-[#e9a8f5] bg-clip-text text-xl font-extrabold text-transparent sm:text-2xl">
          A maior oferta da nossa história
        </p>
        <div className="mt-4 space-y-1 text-sm font-bold sm:text-base">
          <p>2 pós-graduações.</p>
          <p>Pague apenas 1.</p>
          <p>Acesso vitalício à Star Cursos.</p>
        </div>
        <a
          href={blackListaHref(`efisio-artigo-${posicao}`)}
          className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#2fe0d6] px-7 py-3 text-sm font-extrabold uppercase tracking-wide text-[#0b0a14] no-underline hover:brightness-110"
        >
          {sale ? BLACK_CTA_VENDA : "Saiba mais"} <ArrowRight className="h-4 w-4" />
        </a>
      </aside>
    );
  }

  return (
    <aside className="efisio-chevrons overflow-hidden rounded-2xl p-6 text-white sm:p-8">
      <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-[var(--efisio-cyan)]">
        Continue estudando com a FEO
      </p>
      <h2 className="mt-3 text-xl font-extrabold leading-tight sm:text-2xl">{pos.nome}</h2>
      <p className="mt-3 max-w-xl text-sm leading-relaxed text-white/80">{pos.descricao}</p>
      <a
        href={pos.to}
        className="efisio-gradient-bar mt-6 inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-bold uppercase tracking-wide text-[var(--efisio-navy-deep)]"
      >
        Conhecer a pós <ArrowRight className="h-4 w-4" />
      </a>
    </aside>
  );
}
